import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import update from "immutability-helper";
import { get, map, toString, size, uniqBy, filter, includes } from "lodash";

import TableRow from "@material-ui/core/TableRow";

import ScrollableTable from "../Common/Table/ScrollableTable";
import HighlightedText from "../Common/HighlightedText";
import TableCellStyled from "../Common/TableCellStyled";
import TagColor from "../Common/TagColor";
import ProfilePictureAndLink from "../Common/ProfilePictureAndLink";
//import Picture from "../Common/Picture";

import { displayData } from "../../utils/data";
import { getLov } from "../../utils/lov";

//import images from "../../assets/img/images";
import colors from "../../assets/style/colors";
import { I18n } from "@aws-amplify/core";

const columns = [
  {
    name: "profiles_stringFound",
    minWidth: 170,
    width: 170,
  },
  {
    name: "profiles_attribute",
    minWidth: 130,
    width: 130,
    filter: {
      type: "select",
      name: "attribute",
    },
  },
  {
    name: "profiles_profileType",
    minWidth: 130,
    width: 130,
    filter: {
      type: "select",
      name: "profileType",
    },
  },
  {
    name: "profiles_profileName",
    minWidth: 200,
    width: 200,
  },
  {
    name: "profiles_tag",
    minWidth: 130,
    width: 130,
    filter: {
      type: "select",
      name: "tag",
    },
  },
  // {
  //   name: "profiles_profilePhoto",
  //   minWidth: 60,
  //   width: 60,
  // },
];

const styles = {
  tableRowHover: {
    "&:hover": {
      cursor: "pointer",
      backgroundColor: colors.lightGreenBg + " !important",
    },
  },
};

const ProfilesResults = (props) => {
  const { classes, history, profiles, searchValue, language, onRedirect } =
    props;
  const [filters, setFilters] = React.useState({
    profileType: [],
    tag: [],
    attribute: [],
  });
  const [lov, setLov] = React.useState();

  React.useEffect(() => {
    fetchLov();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (lov && filters) {
      const attributes = getResultsAttributes();
      if (size(attributes) > 0) {
        let newLov = lov
          ? update(lov, {
              attribute: { $set: attributes },
            })
          : {
              attribute: attributes,
            };
        setLov(newLov);
        let newFilters = filters
          ? update(filters, {
              attribute: { $set: map(attributes, (a) => a.id) },
            })
          : { attribute: map(attributes, (a) => a.id) };
        setFilters(newFilters);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profiles]);

  const getResultsAttributes = () => {
    const attributes = uniqBy(
      map(profiles, (p) => ({
        id: get(p, ["attributeId"]),
        [`name_${language}`]: get(p, ["attribute"]),
      })),
      (item) => get(item, ["id"])
    );
    return attributes;
  };

  const fetchLov = async () => {
    try {
      const profileTypes = await getLov("profileTypes");
      let tags = await getLov("tags");
      tags.push({
        id: -1,
        name_en: I18n.get("site_noTag"),
        name_fr: I18n.get("site_noTag"),
      });
      const attributes = getResultsAttributes();
      setLov({
        profileType: profileTypes,
        tag: tags,
        attribute: attributes,
      });
      setFilters({
        profileType: map(profileTypes, (p) => p.id),
        tag: map(tags, (t) => t.id),
        attribute: map(attributes, (a) => a.id),
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleFilterChange = (value, filterName) => {
    if (includes(value, "selectAll")) {
      value = map(get(lov, [filterName]), (opt) => opt.id);
    } else if (includes(value, "selectNone")) {
      value = [];
    }
    setFilters(
      update(filters, {
        [filterName]: { $set: value },
      })
    );
  };

  const applyFilters = (item) => {
    let exclude = false;
    if (!includes(get(filters, ["profileType"]), get(item, ["type", "id"]))) {
      exclude = true;
    }
    if (!includes(get(filters, ["tag"]), get(item, ["tag", "id"]) || -1)) {
      exclude = true;
    }
    if (!includes(get(filters, ["attribute"]), get(item, ["attributeId"]))) {
      exclude = true;
    }
    return !exclude;
  };

  const redirectToProfile = (id) => {
    history.push(`/profiles/${id}`);
    if (onRedirect) onRedirect();
  };

  return (
    <ScrollableTable
      columns={columns}
      hasMore={false}
      isFetching={false}
      stickyHeader
      filters={filters}
      lov={lov}
      handleFilterChange={handleFilterChange}
    >
      {map(filter(profiles, applyFilters), (item, index) => (
        <TableRow
          key={index}
          hover
          classes={{
            hover: classes.tableRowHover,
          }}
          style={{
            backgroundColor:
              index % 2 === 0 ? colors.white : colors.tableDarkBg,
          }}
          onClick={() => redirectToProfile(get(item, ["id"]))}
        >
          <TableCellStyled>
            {get(item, ["stringFound"]) ? (
              <HighlightedText
                text={toString(get(item, ["stringFound"]))}
                highlightText={searchValue}
              />
            ) : (
              "-"
            )}
          </TableCellStyled>
          <TableCellStyled className="text-54">
            {displayData(get(item, ["attribute"]))}
          </TableCellStyled>
          <TableCellStyled className="text-54">
            {displayData(get(item, ["type", `name_${language}`]))}
          </TableCellStyled>
          <TableCellStyled>
            <ProfilePictureAndLink
              profile={{
                ...item,
                name:
                  get(item, ["name"]) ||
                  `${get(item, ["firstname"])} ${get(item, ["lastname"])}`,
              }}
              maxHeight={40}
              maxWidth={40}
              noLink
            />
          </TableCellStyled>
          <TableCellStyled>
            {get(item, ["tag"]) ? (
              <TagColor
                color={get(item, ["tag", "color", "rgb"])}
                name={get(item, ["tag", `name_${language}`])}
              />
            ) : (
              "-"
            )}
          </TableCellStyled>
          {/* <TableCellStyled>
            {get(item, ["photo"]) ? (
              <Picture
                url={get(item, ["photo"])}
                maxHeight={40}
                justify="flex-start"
                style={{
                  maxWidth: "40px",
                  maxHeight: "40px",
                  borderRadius: "4px",
                }}
                alt="profile_photo"
              />
            ) : (
              <span style={{ display: "flex" }}>
                <img src={images.noPicture} alt="no_photo" />
              </span>
            )}
          </TableCellStyled> */}
        </TableRow>
      ))}
    </ScrollableTable>
  );
};

export default withRouter(withStyles(styles)(ProfilesResults));
